// extracted by mini-css-extract-plugin
export default {"root":"account2_root__rLDSp","contain":"account2_contain__HwJRw","espace_haut":"account2_espace_haut__8KdUn","espace_bas":"account2_espace_bas__2zFO6"};